export function showMassMedia() {

    function massMedia() {
        const massMediaBtn = document.querySelector('.js-showMassMedia');
        const massMediaWrapper = document.querySelector('.js-massMediaWrapper');
        const massMediaCardLength = document.querySelectorAll('.js-massMediaCard').length;

        let visibleCards = window.innerWidth > 767 && window.innerWidth < 999 ? 2 : 3;

        if (!massMediaBtn) {
            return false;
        }

        if (massMediaCardLength > visibleCards) {
            massMediaBtn.classList.add('is-active')
        }

        massMediaBtn.addEventListener('click', function() {
            massMediaWrapper.classList.toggle('is-active');
            let text = massMediaWrapper.classList.contains('is-active') ? 'Скрыть' : 'Показать ещё';
            massMediaBtn.textContent = text;
        });
    }

    function adaptive(script) {
        script();

        ['resize', 'orientationChange'].forEach( item => {
            window.addEventListener(item, script);
        });
    }

    adaptive(massMedia);
}